import React, { PureComponent } from 'react'
import ui from 'redux-ui'
import TagsApi from "./api/TagsApi"
import { connect } from "react-redux"
import {
    getLabel,
    UPDATE_TAGS_IN_PROGRESS
} from "./TagsData"
import TagsSection from "./TagsSection.jsx"

@ui({
    state: {
        loading: false,
        actionTagType: ''
    },
    reducer: (state, action) => {
        switch (action.type) {
            case UPDATE_TAGS_IN_PROGRESS:
                return state.set('loading', action.status).set('actionTagType', action.tagType)
        }
        return state || new Map()
    }
})

@connect(
    (state, props) => ({
        placeholder: getLabel(state, props)
    })
)
export default class TagsSectionContainer extends PureComponent {

    constructor(props) {
        super(props)

        this.state = {
            availableTags: []
        }
    }

    getAvailableTags() {
        TagsApi.getAvailableTags(this.props.fetchType)
            .then((response) => {
                this.setState({
                    availableTags: response.data
                })
            })
            .catch((error) => {
                console.log('failed to fetch available tags: ' + error)
            })
    }

    render() {
        const { ui, ...rest } = this.props
        const { availableTags } = this.state

        return <TagsSection availableTags={availableTags}
                            loading={ui.loading}
                            actionTagType={ui.actionTagType}
                            autoFocus={false}
                            fetchAvailableTags={() => this.getAvailableTags()}
                            {...rest}/>
    }
}

let propTypes = Object.assign({}, TagsSectionContainer.propTypes)
delete propTypes.fetchAvailableTags
TagsSectionContainer.propTypes = propTypes
